<script>
  import { useNavigate } from 'svelte-navigator';

  import {
    Column,
    Content,
    Grid,
    Header,
    HeaderAction,
    HeaderPanelDivider,
    HeaderPanelLink,
    HeaderPanelLinks,
    HeaderUtilities,
    Row,
    SkipToContent,
  } from 'carbon-components-svelte';

  import User20 from 'carbon-icons-svelte/lib/User20';

  import AppThemeIcon from './components/AppThemeIcon.svelte';
  import CriticalWarnings from './components/CriticalWarnings.svelte';
  import SearchBar from './pages/search/SearchBar.svelte';

  import { userSession } from './stores';

  let isAccountHeaderActionOpen = false;

  const navigate = useNavigate();

  function onClickHome(event) {
    event.preventDefault();
    navigate('/');
  }

  function onSignOut() {
    userSession.signOut();
  }

  $: userEmail = $userSession?.userProfile?.email ?? 'unknown';
</script>

<svelte:head>
  <title>LLG Main Access Control Engine</title>
</svelte:head>
<Header
  href="/"
  on:click={onClickHome}
  companyName="LLG"
  platformName="Main Access Control Engine"
  persistentHamburgerMenu={false}
  expansionBreakpoint={0}
>
  <div class="platform" slot="platform">
    <span class="platform-full">Main Access Control Engine</span>
    <span class="platform-short">MACE</span>
  </div>
  <div slot="skipToContent">
    <SkipToContent />
  </div>

  <HeaderUtilities>
    {#if $userSession.session}
      <SearchBar />
    {/if}
    <AppThemeIcon />
    {#if $userSession.session}
      <HeaderAction
        aria-label={`${isAccountHeaderActionOpen ? 'Close' : 'Open'} account menu`}
        icon={User20}
        bind:isAccountHeaderActionOpen
      >
        <HeaderPanelLinks>
          <HeaderPanelDivider><div class="user-email">{userEmail}</div></HeaderPanelDivider>
          <HeaderPanelLink on:click={onSignOut}>Log out</HeaderPanelLink>
        </HeaderPanelLinks>
      </HeaderAction>
    {/if}
  </HeaderUtilities>
</Header>
<CriticalWarnings />
<Content>
  <Grid noGutterLeft noGutterRight>
    <Row>
      <Column>
        <slot />
      </Column>
    </Row>
  </Grid>
</Content>

<style>
  .platform {
    font-variant: small-caps;
  }

  .platform-short {
    display: none;
  }

  .user-email {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 500px) {
    .platform-full {
      display: none;
    }

    .platform-short {
      display: inline;
    }
  }
</style>
